export default __webpack_public_path__ + "static/media/confetti1.a7321833.png";